import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ValidationErrors,
  Validators
} from "@angular/forms";
import { InputComponent } from '@shared/controls/input/input.component';
import { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityApiService } from '../../services/security-api.service';
import { NumbersValidators } from '../../validators/numbers.validators';
import { ValidationErrorComponent } from '@shared/controls/validation-error/validation-error.component';
import { FormSwitchButtonComponent } from '@shared/controls/form-switch-button/form-switch-button.component';
import { LinkComponent } from '@shared/components/commons/link/link.component';
import { ClientSecurityTransaction } from '@models/security-transactions/client-security-transaction';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'input-certificate-number',
  standalone: true,
  imports: [
    FormsModule,
    FormSwitchButtonComponent,
    CommonModule,
    LinkComponent,
    ValidationErrorComponent,
    NgbTooltip
],
  templateUrl: '../input-number/input-number.component.html',
  styleUrl: `../input/input.component.scss`,
})
export class InputCertificateNumberComponent extends InputComponent implements OnInit  {
  securityService = inject(SecurityApiService);
  cdr = inject(ChangeDetectorRef);

  @Input() public entityId!: string;
  @Input() override customErrors: Record<string, string> = {
    ...NumbersValidators.numbersValidatorErrors,
    invalidCertificateNumber: 'This certificate number already exists in the Share Register.'
  };
  @Input() min: number | null = 1;
  @Input() max: number | null = null;
  @Input() transactionsList: ClientSecurityTransaction[] = [];
  @Input() isRequired = true;
  @Input() tooltipMessage: string | null = null;

  ngOnInit() {
    if (this.ngControl.control) {
      this.ngControl.control.addValidators(
        [
          NumbersValidators.isNumber,
          this.CertificateNumberValidator.bind(this)
        ]);

      if (this.isRequired) {
        this.ngControl.control.setValidators(Validators.required);
      }
    }

    const maxNumber = this.transactionsList.reduce((max, share) => Math.max(max, Number(share.shareCertificateNumber) || 0), 0)
    this.value = "" + (maxNumber + 1);
  }

  CertificateNumberValidator(control: AbstractControl): ValidationErrors | null {
    const number = control.value as string ?? '';
    const containsNumber = this.transactionsList.some(share => share.shareCertificateNumber == number);
    return containsNumber ? { invalidCertificateNumber: true } : null;
  }
}
